import {
  formatCurrency,
  membershipHelper,
  ordinal,
  pluralize,
} from "@gymflow/helpers";
import { Currency, CurrentSubscriptionDTO } from "@gymflow/types";
import { t } from "i18next";
import moment from "moment";

export const getBillingText = (
  currentMembership: CurrentSubscriptionDTO | undefined,
  defaultCurrency: Currency,
) => {
  if (!currentMembership) {
    return "";
  }

  const price = formatCurrency(currentMembership.price, defaultCurrency);

  if (
    currentMembership.type === "TRIAL" ||
    currentMembership.type === "PREPAID"
  ) {
    return t(
      "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.billing.onceOff",
      { price },
    );
  }

  const billingPeriod = currentMembership.billingPeriod;
  const billingType = currentMembership.billingType;

  if (!billingPeriod || !billingType) {
    return "";
  }

  const billingDay = membershipHelper.getBillingDay(currentMembership);
  const key = pluralize("singular", "plural", billingPeriod);
  const payload = {
    price,
    billingDay:
      billingType === "MONTHLY" ? ordinal(Number(billingDay)) : billingDay,
    billingPeriod: billingPeriod.toString(),
  };

  return t(
    `pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.billing.${billingType.toLowerCase()}.${key}`,
    payload,
  );
};

export const getMembershipTypeText = (
  currentMembership: CurrentSubscriptionDTO | undefined,
) => {
  if (!currentMembership) {
    return "";
  }
  if (currentMembership.type === "TRIAL") {
    return t(
      `pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.membershipType.trial`,
    );
  }

  if (!currentMembership.type) {
    return "";
  }

  return t(
    `pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.membershipType.${currentMembership.type.toLowerCase()}`,
  );
};

export const getTillDateText = (
  currentMembership: CurrentSubscriptionDTO,
  timezone: string,
) => {
  if (!currentMembership || !currentMembership.endContractDate) {
    return "";
  }

  const date = moment(currentMembership.endContractDate)
    .tz(timezone)
    .format("D MMM, YYYY");

  return t(
    "pages.hostedPagesProfile.hostedPagesProfileMembershipStatuses.tillDate",
    { date },
  );
};
